import { render, staticRenderFns } from "./SettingGoldMiniQuestAndDailyQuest.vue?vue&type=template&id=5ee444ae&scoped=true&"
import script from "./SettingGoldMiniQuestAndDailyQuest.vue?vue&type=script&lang=js&"
export * from "./SettingGoldMiniQuestAndDailyQuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee444ae",
  null
  
)

export default component.exports